/** Mascaramento de destino para telas de verificação (B4 §4). */

export function maskEmail(email: string): string {
  const value = email.trim()
  const [local, domain] = value.split('@')
  if (!domain || !local) return value
  const head = local.slice(0, 2)
  return `${head}${'•'.repeat(Math.max(3, local.length - 2))}@${domain}`
}

/** Telefone BR (10-11 dígitos, com ou sem +55): (11) 9••••-1234. */
export function maskPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  const national =
    digits.startsWith('55') && digits.length >= 12 ? digits.slice(2) : digits
  if (national.length < 10) return raw.trim()
  const ddd = national.slice(0, 2)
  const last4 = national.slice(-4)
  const masked = '•'.repeat(Math.max(4, national.length - 6))
  return `(${ddd}) ${masked}-${last4}`
}

/**
 * Escolhe o mascaramento certo para o destino do desafio. E-mail é default
 * quando o texto tem "@"; o resto é tratado como telefone.
 */
export function maskDestination(raw: string | undefined): string {
  if (!raw) return ''
  return raw.includes('@') ? maskEmail(raw) : maskPhone(raw)
}
